import { render, staticRenderFns } from "./create-deliveryweek.vue?vue&type=template&id=f325aa6c&scoped=true"
import script from "./create-deliveryweek.vue?vue&type=script&lang=js"
export * from "./create-deliveryweek.vue?vue&type=script&lang=js"
import style0 from "./create-deliveryweek.vue?vue&type=style&index=0&id=f325aa6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f325aa6c",
  null
  
)

export default component.exports